import React, { useState } from "react";
import { Paper, Tab, Tabs } from "@material-ui/core";
import { useSnackbar } from 'notistack';
import ALPDetails from './ALPDetails';
import AcquisitionDetails from './AcquisitionDetails';
import LinkSvEvents from "./LinkSvEvents";
const APU = ({getResponseBack ,assetInfoData}) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isEdit, setEdit] = useState(false);
    const [tabIndex, setTabIndex] = useState('basic-info');
    return (
        <div>
            <div>
                <Paper elevation={0} className="console-paper" style={{margin:'0px 10px 2px 10px'}}>
                    <Tabs indicatorColor='primary' value={tabIndex} onChange={(event, newValue) => setTabIndex(newValue)} variant='fullWidth'>
                        <Tab label='Basic Details' value='basic-info' />
                        <Tab label='Acquisition & Other Details' value='acquisition-info' />
                        <Tab label="Sv Events" value={'sv-events'}/>
                    </Tabs>
                </Paper>
                { tabIndex === 'basic-info' ? <ALPDetails assetInfoData={assetInfoData} getResponseBack={getResponseBack} />:null}
                { tabIndex === 'acquisition-info' ? <AcquisitionDetails assetInfoData={assetInfoData}  />: null }
                { tabIndex === 'sv-events' ? <LinkSvEvents assetInfoData={assetInfoData} />:null}    
            </div>
        </div>
    )
}
export default APU;